import {isNumber,size} from 'lodash-es'
export const dispatchStatusColor = ({ value, isBackground = false, isText = false }) => {//呼叫系统-线索库-派单状态枚举颜色
    return '#' + {
      '信息': isBackground ? 'FDE6E6' : isText ? 'F25A5A' : 'F9B5B5',      //初始状态
      '呼叫待定': isBackground ? 'FFF7E3' : 'FFC740',   //呼叫待定
      '线索': isBackground ? 'E1F2FF' : '33A9FF',      //线索
      '呼叫有效': isBackground ? 'E1F2FF' : '33A9FF',      //呼叫有效
      '无效': isBackground ? 'FAFAFA' : '999999',    //无效
    }[value || '无效']
  }
export function getNumberUnit(num, defaultUnit = '个', toFixed) {
    let value = num || 0;
    let unit = defaultUnit;
    let state = false;
    if (value < 0) {
      value = value + (-value * 2)
      state = true
    }
    if (value > 10000 && value < 100000000) {
      value = value / 10000;
      unit = '万';
    }
    if (value >= 100000000) {
      value = value / 100000000;
      unit = '亿';
    }
    if (toFixed > 0) {
      value = parseFloat(value).toFixed(toFixed)
      let str = value.split('.')[1].split("")
      let status = str.every(d => d == 0)
      if (status) {
        value = value.split('.')[0]
      }
    } else {
      value = ~~value
    }
    if (state) value = -value
    return {
      value,
      unit,
      numberValue: value + unit
    };
  }
  // 删除对象中 空数组/空对象/空字符串
export const deleteBlankObj = (data) => {
    let _data = { ...data }
    for (const k in _data) {
      if ((_data[k] + '') !== 'false' && (_data[k] + '') !== 'true' && !isNumber(data[k])) {
        if (!size(_data[k])) {
          delete _data[k]  // 检查是否是空值，如果是空值则删除
        }
      }
    }
    return _data
  }